import React from 'react';

const PackageVariantsContext = React.createContext({
  selectedVariants: [],
  cartErrors: null,
  selectVariants: () => {},
  castCartError: () => {},
});

export default PackageVariantsContext;
